// @ts-nocheck
import React from 'react';

/**
 * FormGroup — label + control + help/error. Wrap an Input/Select/Textarea
 * (or anything custom) with a label row that supports an optional `optional`
 * tag or a right-side link/action slot.
 */
const FormGroup = ({
  label,
  htmlFor,
  optional,
  rightSlot,
  help,
  error,
  className = '',
  children,
}) => (
  <div className={['mb-4', className].join(' ')}>
    {(label || rightSlot) && (
      <div className="flex items-baseline justify-between mb-1.5">
        {label && (
          <label htmlFor={htmlFor} className="text-[12.5px] font-medium text-mov-ink">
            {label}
            {optional && <span className="ml-2 text-mov-ink-mute font-normal">Optional</span>}
          </label>
        )}
        {rightSlot}
      </div>
    )}
    {children}
    {(help || error) && (
      <div className={['text-[11.5px] mt-1.5', error ? 'text-mov-danger' : 'text-mov-ink-mute'].join(' ')}>
        {error || help}
      </div>
    )}
  </div>
);

export default FormGroup;
